function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".\\37 0b2ccb0-a788-4665-96ed-a76fb0b00ace{fill:#f0b4b9;}.\\32 bd9510a-656a-44be-8f79-baeda0a36386{fill:#d6d7ed;}.\\34 201fd5b-3fe3-41ac-a933-80e154de32cd{fill:#fff;}.\\33 5fb3b5e-ab7e-4c57-a179-707f241d92cc{fill:#3f3d56;}.e6795f28-239c-4d84-aad5-4f90a703fd68{fill:none;stroke:#633a69;stroke-miterlimit:10;stroke-width:0.377px;}.f97c7835-daa3-40af-8118-49eca9830353{fill:#633a69;}"));

var _ref3 = /*#__PURE__*/React.createElement("title", null, "Hardware-01");

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "9f417e20-d7a2-4a7e-bb4d-c160386e3e4b",
  "data-name": "Layer 4"
}, /*#__PURE__*/React.createElement("path", {
  className: "70b2ccb0-a788-4665-96ed-a76fb0b00ace",
  d: "M8.928,85.153A7.85,7.85,0,0,0,16.8,93.281H53a8.2,8.2,0,0,0-9.733-2.421A11.609,11.609,0,0,0,32.13,82.525c-.142,0-.282.006-.423.011A11.606,11.606,0,0,0,8.936,84.982Q8.931,85.068,8.928,85.153Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "70b2ccb0-a788-4665-96ed-a76fb0b00ace",
  d: "M160.927,44.313a15.106,15.106,0,0,0-29.638-3.185c-.183-.007-.366-.014-.55-.014a15.109,15.109,0,0,0-14.494,10.85,10.676,10.676,0,0,0-12.668,3.151H150.7a10.218,10.218,0,0,0,10.24-10.579Q160.933,44.424,160.927,44.313Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "70b2ccb0-a788-4665-96ed-a76fb0b00ace",
  d: "M1.721,21.047a16.989,16.989,0,0,1,33.332-3.582c.206-.007.411-.016.619-.016a16.993,16.993,0,0,1,16.3,12.2A12.007,12.007,0,0,1,66.22,33.2H13.226A11.491,11.491,0,0,1,1.709,21.3Q1.714,21.172,1.721,21.047Z"
}));

var _ref5 = /*#__PURE__*/React.createElement("g", {
  id: "12d3577d-4c94-4cdc-b732-280d3ceb275d",
  "data-name": "Layer 3"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "2bd9510a-656a-44be-8f79-baeda0a36386",
  points: "106.931 20.99 57.768 20.99 33.186 63.566 57.768 106.143 106.931 106.143 131.513 63.566 106.931 20.99"
}), /*#__PURE__*/React.createElement("path", {
  className: "4201fd5b-3fe3-41ac-a933-80e154de32cd",
  d: "M61.883,99.015h40.933l20.467-35.449L102.816,28.117H61.883L41.416,63.566Z"
}), /*#__PURE__*/React.createElement("rect", {
  className: "35fb3b5e-ab7e-4c57-a179-707f241d92cc",
  y: 107.408,
  width: 164.5,
  height: 0.597
}), /*#__PURE__*/React.createElement("line", {
  className: "e6795f28-239c-4d84-aad5-4f90a703fd68",
  x1: 57.514,
  y1: 67.911,
  x2: 73.1,
  y2: 67.911
}), /*#__PURE__*/React.createElement("polyline", {
  className: "e6795f28-239c-4d84-aad5-4f90a703fd68",
  points: "55.202 61.608 66.773 61.608 66.78 61.608 78.853 73.681 78.853 99.084"
}), /*#__PURE__*/React.createElement("line", {
  className: "e6795f28-239c-4d84-aad5-4f90a703fd68",
  x1: 54.204,
  y1: 52.427,
  x2: 63.385,
  y2: 61.608
}), /*#__PURE__*/React.createElement("line", {
  className: "e6795f28-239c-4d84-aad5-4f90a703fd68",
  x1: 62.758,
  y1: 53.247,
  x2: 58.891,
  y2: 57.114
}), /*#__PURE__*/React.createElement("polyline", {
  className: "e6795f28-239c-4d84-aad5-4f90a703fd68",
  points: "67.409 58.338 81.369 72.297 81.369 99.21"
}), /*#__PURE__*/React.createElement("line", {
  className: "e6795f28-239c-4d84-aad5-4f90a703fd68",
  x1: 83.632,
  y1: 48.906,
  x2: 70.805,
  y2: 61.733
}), /*#__PURE__*/React.createElement("polyline", {
  className: "e6795f28-239c-4d84-aad5-4f90a703fd68",
  points: "71.559 33.06 71.559 44.378 79.86 52.679"
}), /*#__PURE__*/React.createElement("line", {
  className: "e6795f28-239c-4d84-aad5-4f90a703fd68",
  x1: 87.279,
  y1: 65.318,
  x2: 87.279,
  y2: 37.587
}), /*#__PURE__*/React.createElement("line", {
  className: "e6795f28-239c-4d84-aad5-4f90a703fd68",
  x1: 87.279,
  y1: 45.887,
  x2: 79.419,
  y2: 38.027
}), /*#__PURE__*/React.createElement("polyline", {
  className: "e6795f28-239c-4d84-aad5-4f90a703fd68",
  points: "109.539 48.969 99.321 48.969 102.245 46.045 94.071 54.219 94.071 49.157 94.071 61.859 83.632 72.297 83.632 99.21"
}), /*#__PURE__*/React.createElement("polyline", {
  className: "e6795f28-239c-4d84-aad5-4f90a703fd68",
  points: "105.432 64.343 95.371 64.343 95.36 64.343 85.896 73.806 85.896 99.21"
}), /*#__PURE__*/React.createElement("polyline", {
  className: "e6795f28-239c-4d84-aad5-4f90a703fd68",
  points: "111.321 59.764 97.928 59.764 97.833 59.764 103.076 54.522 111.227 54.522"
}), /*#__PURE__*/React.createElement("polyline", {
  className: "e6795f28-239c-4d84-aad5-4f90a703fd68",
  points: "66.146 42.091 66.146 47.091 73.188 54.134 68.472 54.134 60.455 46.116"
}), /*#__PURE__*/React.createElement("line", {
  className: "e6795f28-239c-4d84-aad5-4f90a703fd68",
  x1: 79.671,
  y1: 57.43,
  x2: 79.671,
  y2: 65.852
}), /*#__PURE__*/React.createElement("line", {
  className: "e6795f28-239c-4d84-aad5-4f90a703fd68",
  x1: 84.874,
  y1: 71.055,
  x2: 74.468,
  y2: 60.649
}), /*#__PURE__*/React.createElement("polyline", {
  className: "e6795f28-239c-4d84-aad5-4f90a703fd68",
  points: "80.143 42.869 80.143 48.906 74.106 42.869"
}), /*#__PURE__*/React.createElement("polyline", {
  className: "e6795f28-239c-4d84-aad5-4f90a703fd68",
  points: "83.731 52.895 83.731 61.777 88.997 67.043"
}), /*#__PURE__*/React.createElement("polyline", {
  className: "e6795f28-239c-4d84-aad5-4f90a703fd68",
  points: "96.586 34.176 96.586 42.869 90.679 48.776 90.644 48.811 90.644 39.757"
}), /*#__PURE__*/React.createElement("line", {
  className: "e6795f28-239c-4d84-aad5-4f90a703fd68",
  x1: 93.788,
  y1: 32.274,
  x2: 93.788,
  y2: 45.667
}), /*#__PURE__*/React.createElement("line", {
  className: "e6795f28-239c-4d84-aad5-4f90a703fd68",
  x1: 90.644,
  y1: 60.947,
  x2: 90.644,
  y2: 48.776
}), /*#__PURE__*/React.createElement("circle", {
  className: "f97c7835-daa3-40af-8118-49eca9830353",
  cx: 90.644,
  cy: 40.067,
  r: 1.572
}), /*#__PURE__*/React.createElement("circle", {
  className: "f97c7835-daa3-40af-8118-49eca9830353",
  cx: 96.586,
  cy: 35.266,
  r: 1.572
}), /*#__PURE__*/React.createElement("circle", {
  className: "f97c7835-daa3-40af-8118-49eca9830353",
  cx: 93.788,
  cy: 32.024,
  r: 1.572
}), /*#__PURE__*/React.createElement("circle", {
  className: "4201fd5b-3fe3-41ac-a933-80e154de32cd",
  cx: 93.788,
  cy: 32.024,
  r: 1.11
}), /*#__PURE__*/React.createElement("circle", {
  className: "f97c7835-daa3-40af-8118-49eca9830353",
  cx: 83.731,
  cy: 52.895,
  r: 1.572
}), /*#__PURE__*/React.createElement("circle", {
  className: "f97c7835-daa3-40af-8118-49eca9830353",
  cx: 75.426,
  cy: 61.608,
  r: 1.572
}), /*#__PURE__*/React.createElement("circle", {
  className: "f97c7835-daa3-40af-8118-49eca9830353",
  cx: 79.86,
  cy: 57.961,
  r: 1.572
}), /*#__PURE__*/React.createElement("circle", {
  className: "4201fd5b-3fe3-41ac-a933-80e154de32cd",
  cx: 79.86,
  cy: 57.961,
  r: 1.11
}), /*#__PURE__*/React.createElement("circle", {
  className: "f97c7835-daa3-40af-8118-49eca9830353",
  cx: 63.11,
  cy: 52.895,
  r: 1.572
}), /*#__PURE__*/React.createElement("circle", {
  className: "4201fd5b-3fe3-41ac-a933-80e154de32cd",
  cx: 63.11,
  cy: 52.895,
  r: 1.11
}), /*#__PURE__*/React.createElement("circle", {
  className: "f97c7835-daa3-40af-8118-49eca9830353",
  cx: 111.227,
  cy: 54.522,
  r: 1.572
}), /*#__PURE__*/React.createElement("circle", {
  className: "4201fd5b-3fe3-41ac-a933-80e154de32cd",
  cx: 111.227,
  cy: 54.522,
  r: 1.11
}), /*#__PURE__*/React.createElement("circle", {
  className: "f97c7835-daa3-40af-8118-49eca9830353",
  cx: 102.245,
  cy: 46.045,
  r: 1.572
}), /*#__PURE__*/React.createElement("circle", {
  className: "4201fd5b-3fe3-41ac-a933-80e154de32cd",
  cx: 102.245,
  cy: 46.045,
  r: 1.11
}), /*#__PURE__*/React.createElement("circle", {
  className: "f97c7835-daa3-40af-8118-49eca9830353",
  cx: 58.795,
  cy: 67.911,
  r: 1.572
}), /*#__PURE__*/React.createElement("circle", {
  className: "4201fd5b-3fe3-41ac-a933-80e154de32cd",
  cx: 58.795,
  cy: 67.911,
  r: 1.11
}), /*#__PURE__*/React.createElement("circle", {
  className: "f97c7835-daa3-40af-8118-49eca9830353",
  cx: 80.143,
  cy: 44.472,
  r: 1.572
}), /*#__PURE__*/React.createElement("circle", {
  className: "4201fd5b-3fe3-41ac-a933-80e154de32cd",
  cx: 80.143,
  cy: 44.472,
  r: 1.11
}), /*#__PURE__*/React.createElement("circle", {
  className: "f97c7835-daa3-40af-8118-49eca9830353",
  cx: 66.255,
  cy: 42.869,
  r: 1.572
}), /*#__PURE__*/React.createElement("circle", {
  className: "4201fd5b-3fe3-41ac-a933-80e154de32cd",
  cx: 66.255,
  cy: 42.869,
  r: 1.11
}), /*#__PURE__*/React.createElement("circle", {
  className: "f97c7835-daa3-40af-8118-49eca9830353",
  cx: 71.559,
  cy: 33.597,
  r: 1.572
}), /*#__PURE__*/React.createElement("circle", {
  className: "f97c7835-daa3-40af-8118-49eca9830353",
  cx: 94.092,
  cy: 49.685,
  r: 1.572
}), /*#__PURE__*/React.createElement("circle", {
  className: "f97c7835-daa3-40af-8118-49eca9830353",
  cx: 80.143,
  cy: 38.75,
  r: 1.572
}), /*#__PURE__*/React.createElement("circle", {
  className: "f97c7835-daa3-40af-8118-49eca9830353",
  cx: 87.279,
  cy: 36.796,
  r: 1.572
}), /*#__PURE__*/React.createElement("circle", {
  className: "f97c7835-daa3-40af-8118-49eca9830353",
  cx: 84.426,
  cy: 48.112,
  r: 1.572
}), /*#__PURE__*/React.createElement("circle", {
  className: "f97c7835-daa3-40af-8118-49eca9830353",
  cx: 67.827,
  cy: 57.961,
  r: 1.572
}), /*#__PURE__*/React.createElement("circle", {
  className: "f97c7835-daa3-40af-8118-49eca9830353",
  cx: 74.389,
  cy: 43.099,
  r: 1.572
}), /*#__PURE__*/React.createElement("circle", {
  className: "f97c7835-daa3-40af-8118-49eca9830353",
  cx: 60.825,
  cy: 46.54,
  r: 1.572
}), /*#__PURE__*/React.createElement("circle", {
  className: "f97c7835-daa3-40af-8118-49eca9830353",
  cx: 54.456,
  cy: 52.679,
  r: 1.572
}), /*#__PURE__*/React.createElement("circle", {
  className: "f97c7835-daa3-40af-8118-49eca9830353",
  cx: 109.539,
  cy: 48.906,
  r: 1.572
}), /*#__PURE__*/React.createElement("circle", {
  className: "f97c7835-daa3-40af-8118-49eca9830353",
  cx: 55.202,
  cy: 61.641,
  r: 1.572
}), /*#__PURE__*/React.createElement("circle", {
  className: "f97c7835-daa3-40af-8118-49eca9830353",
  cx: 111.321,
  cy: 59.764,
  r: 1.572
}), /*#__PURE__*/React.createElement("circle", {
  className: "f97c7835-daa3-40af-8118-49eca9830353",
  cx: 105.735,
  cy: 64.343,
  r: 1.572
}), /*#__PURE__*/React.createElement("circle", {
  className: "f97c7835-daa3-40af-8118-49eca9830353",
  cx: 90.644,
  cy: 60.947,
  r: 1.572
}), /*#__PURE__*/React.createElement("circle", {
  className: "4201fd5b-3fe3-41ac-a933-80e154de32cd",
  cx: 90.644,
  cy: 60.947,
  r: 1.11
}));

var SvgHardware = function SvgHardware(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 163.336 110",
    ref: svgRef
  }, props), _ref2, title === undefined ? _ref3 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref4, _ref5);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgHardware, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Hardware.49f127fe.svg";
export { ForwardRef as ReactComponent };